// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eaaf8c5b","453":"1f716a01","732":"5a5266c0","977":"10a75e13"}[chunkId] + ".chunk.js";
};